<template>
    <v-container>
        <v-layout row class="justify-start">
            <v-flex>
                <v-subheader class="page-header">Message Groups</v-subheader>
            </v-flex>
        </v-layout>
        <v-spacer />
        <router-view :messageGroups="messageGroups" />
    </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'MessageGroup',
    computed: {
        ...mapState({
            messageGroups: 'messageGroups'
        })
    },
    mounted() {
        this.initialize();
    },
    methods: {
        initialize() {
            this.getMessageGroups();
        },

        getMessageGroups() {
            this.$store.dispatch('messageGroupRead');
        }
    }
};
</script>
